import CustomList from "components/list/custom";
import React, { useState } from "react";
import { DisplayPercentage } from "components/display/percentage";
import { DisplayHours } from "components/display/hours";
import { CURRENT_MONTH_END_DATE, CURRENT_MONTH_START_DATE } from "@/lib/utils";
import { Link } from "react-router-dom";
import { createFilteredUrl } from "@/hooks/useUrlState";
import DepartmentFilers from "./filters";

const TimesheetDepartmentUtilization = () => {
  const defaultFilters = {
    type: "department",
    startDate: CURRENT_MONTH_START_DATE,
    endDate: CURRENT_MONTH_END_DATE,
  };

  const [filters, setFilters] = useState(null);

  const columns = [
    {
      id: "department",
      accessorKey: "department",
      header: "Department",
      cell: ({ getValue }) => {
        const department = getValue();

        const newFilters = {
          department: department?.id,
          startDate: filters?.startDate,
          endDate: filters?.endDate,
        };

        return (
          <Link
            to={createFilteredUrl("../../employees", newFilters)}
            className="capitalize hover:underline "
          >
            {department?.name}
          </Link>
        );
      },
    },
    {
      id: "availableEmployees",
      accessorKey: "availableEmployees",
      header: "Available Employees",
    },
    {
      id: "availableHours",
      accessorKey: "availableHours",
      header: "Available Hours",
    },
    {
      id: "totalLoggedHours",
      accessorKey: "totalLoggedHours",
      header: "Logged Hours",
      cell: ({ getValue }) => <DisplayHours value={getValue()} precision={0} />,
    },

    {
      id: "totalDraftHours",
      accessorKey: "totalDraftHours",
      header: "Draft Hours",
      cell: ({ getValue }) => <DisplayHours value={getValue()} precision={0} />,
    },
    {
      id: "totalHours",
      accessorKey: "totalApprovedHours",
      header: "Approved / Unapproved / Unreviewed / Free",
      cell: ({ row }) => {
        const approved = row.original.totalApprovedHours;
        const unapproved = row.original.totalUnapprovedHours;
        const unreviewed = row.original.totalNotReviewedHours;
        const free = row.original.totalFreeHours;
        return (
          <div>
            <span className="text-green-500">
              <DisplayHours value={approved} precision={0} />
            </span>{" "}
            /{" "}
            <span className="text-red-500">
              <DisplayHours value={unapproved} precision={0} />
            </span>{" "}
            /{" "}
            <span className="text-zinc-500">
              <DisplayHours value={unreviewed} precision={0} />
            </span>{" "}
            /{" "}
            <span className="text-zinc-500">
              <DisplayHours value={free} precision={0} />
            </span>
          </div>
        );
      },
    },
    {
      id: "totalHoursPercentage",
      accessorKey: "totalHoursPercentage",
      header: "Total Hours Percentage",
      cell: ({ row }) => {
        const billablePercentage = row.original.totalBillablePercentage;
        const nonBillablePercentage = row.original.totalNonBillablePercentage;
        const unReviewedPercentage =
          row.original.totalNotReviewedHoursPercentage;
          const freePercentage = row.original.totalFreeHoursPercentage;

        return (
          <div className="">
            <span className="text-green-500">
              <DisplayPercentage value={billablePercentage} precision={0} />
            </span>{" "}
            /{" "}
            <span className="text-red-500">
              <DisplayPercentage value={nonBillablePercentage} precision={0} />
            </span>{" "}
            /{" "}
            <span className="text-zinc-500">
              <DisplayPercentage value={unReviewedPercentage} precision={0} />
            </span>{" "}
            /{" "}
            <span className="text-zinc-500">
              <DisplayPercentage value={freePercentage} precision={0} />
            </span>
          </div>
        );
      },
    },

    {
      id: "departmentUtilization",
      accessorKey: "departmentUtilization",
      header: "Utilization (%)",
      cell: ({ getValue }) => (
        <DisplayPercentage value={getValue()} precision={0} />
      ),
    },
  ];

  return (
    <div className="flex-1 overflow-auto">
      <CustomList
        endPoint="custom-ui/dashboard"
        filters={defaultFilters}
        columns={columns}
        renderFilters={DepartmentFilers}
        onFiltersChange={setFilters}
        storageKey={"department"}
        teleportFilters={true}
        hidePagination={true}
      />
    </div>
  );
};

export default TimesheetDepartmentUtilization;
